export default __webpack_public_path__ + "static/media/colosePopup.32785f89.svg";